import { useState } from "react";
import { Button } from "react-bootstrap";
import PaymentsTable from "../../../components/Tables/PaymentsTable";
import { usePayment } from "../../../hooks/usePayment";
import FormCobranca from "./FormCobranca";

function ContasReceber() {
  const {
    payments,
    isFetching,
    isLoading,
    createPayment,
    updatePayment,
    deletePayment,
    isCreating,
    isUpdating,
    isDeleting,
  } = usePayment();

  const [showForm, setShowForm] = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);

  const openCreate = () => {
    setEditingPayment(null);
    setShowForm(true);
  };

  const openEdit = (payment) => {
    setEditingPayment(payment);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setEditingPayment(null);
  };

  const handleSubmit = async (payload) => {
    if (editingPayment?.id) {
      await updatePayment({ id: editingPayment.id, ...payload });
    } else {
      await createPayment(payload);
    }
    closeForm();
  };

  const handleDelete = async (payment) => {
    const label =
      payment.description ||
      payment.client ||
      `cobrança #${payment.id}`;
    const confirmed = window.confirm(`Excluir a cobrança "${label}"?`);
    if (!confirmed) return;
    await deletePayment(payment.id);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-0">Contas a Receber</h5>
          <small className="text-muted">
            Cobranças do escritório com status automático (Aberto, Parcial,
            Recebido, Atrasado).
          </small>
        </div>
        <Button
          type="button"
          className="btn-bg-primary text-dark borderColor"
          onClick={openCreate}
        >
          <i className="bi bi-plus-lg" /> Nova Cobrança
        </Button>
      </div>

      <PaymentsTable
        isFetching={isLoading || isFetching}
        payments={payments}
        onEdit={openEdit}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />

      <FormCobranca
        show={showForm}
        onHide={closeForm}
        payment={editingPayment}
        onSubmit={handleSubmit}
        isSubmitting={isCreating || isUpdating}
      />
    </div>
  );
}

export default ContasReceber;
